<template>
  <div>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title class="text-h5">
          {{ dialogTitle }}
        </v-card-title>

        <v-card-text>{{ dialogMessage }}</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn rounded text @click="onGoMain" v-if="dialogError">
            Закрыть
          </v-btn>
          <v-btn rounded text @click="onGoMain" v-if="!dialogError"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-show="loading" class="progress-logo">
      <v-layout align-center justify-center column fill-height>
        <v-progress-circular
          indeterminate
          color="primary"
          :size="70"
          :width="5"
        ></v-progress-circular>
      </v-layout>
    </div>

    <div v-show="!loading && !openCamera">
      <v-card class="mx-auto" max-width="auto" v-if="upd && !isCorrectingSum">
        <v-card-text>
          <p class="text-h5 text--primary">УПД №{{ upd.docNumber }}</p>
          <p>
            <b>{{ upd.contractor.contract.number }}</b>
          </p>
          <p>{{ upd.contractor.name }}</p>
          <p>{{ upd.deliveryAddress.name }}</p>

          <v-simple-table
            class="mb-6"
            v-show="!(upd.contractor.contract.contractType === 3 && isPaid)"
          >
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>Баланс до отгрузки</td>
                  <td>
                    {{ (upd.totalPay - upd.clientPay).toFixed(2) }}
                    <span class="currency-rub"></span>
                  </td>
                </tr>
                <tr>
                  <td>Сумма отгрузки из УПД</td>
                  <td>{{ upd.totalPay }} <span class="currency-rub"></span></td>
                </tr>
                <tr>
                  <td><b>Взять с клиента (с учетом переплаты)</b></td>
                  <td>
                    <span class="brg-mark"
                      ><span class="text-h6">{{ updSum }}</span>
                      <span class="currency-rub"></span
                    ></span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-simple-table class="mb-6" v-show="goodsForReturnIsAvailable">
            <template v-slot:default>
              <tbody>
                <tr
                  v-if="
                    upd.contractor.contract.contractType === 3 &&
                    upd.clientPaid.toFixed(2) > 0
                  "
                >
                  <td>Пробит чек на сумму</td>
                  <td>
                    <span class="brg-mark"
                      ><span class="text-h6">{{
                        upd.clientPaid.toFixed(2)
                      }}</span>
                      <span class="currency-rub"></span
                    ></span>
                  </td>
                </tr>
                <tr v-if="isPaid">
                  <td>Сумма корректировки долга</td>
                  <td>
                    <div>
                      {{ debt.toFixed(2) }} <span class="currency-rub"></span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-spacer></v-spacer>

          <v-alert
            closable
            v-if="updRejectResultData !== null"
            :type="updRejectResultData.type"
          >
            {{ updRejectResultData.text }}
          </v-alert>

          <v-btn
            block
            class="goods-link"
            @click="onShowDetails"
            v-if="
              !isRejected &&
              !showDetails &&
              goodsForReturnIsAvailable &&
              updRejectResultData === null
            "
          >
            <v-icon dark> mdi-menu-down-outline </v-icon>
            Удаление товарных позиций<br />(отказ/недостача)
          </v-btn>
          <v-btn
            block
            class="goods-link"
            @click="onShowDetails"
            v-if="
              showDetails &&
              updRejectResultData === null &&
              goodsForReturnIsAvailable
            "
          >
            <v-icon dark> mdi-menu-up-outline </v-icon>
            Скрыть
          </v-btn>

          <div v-show="showDetails && updRejectResultData === null">
            <template>
              <v-row justify="center">
                <v-dialog
                  v-model="updRejectDialog"
                  persistent
                  max-width="600px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      block
                      class="goods-link error"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="isAllGoodsRemoveButtonDisabled"
                    >
                      <v-icon dark> mdi-cancel </v-icon>
                      Отказ от всех позиций
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">Отказ от ВСЕХ позиций</span>
                    </v-card-title>

                    <v-card-text v-if="this.upd.uksCount > 0">
                      <div class="center">
                        <v-radio-group
                          v-model="removeAllGoodsReason"
                          class="text-right"
                          row
                        >
                          <v-radio label="Отказ" value="14"></v-radio>
                          <v-radio label="Недостача" value="25"></v-radio>
                        </v-radio-group>
                      </div>
                    </v-card-text>

                    <v-card-actions class="text-right">
                      <v-btn text @click="onRejectDeleteAllButton"
                        >Отмена</v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="onSubmitDeleteAllButton"
                        :disabled="
                          this.upd.uksCount > 0
                            ? null === removeAllGoodsReason
                            : false
                        "
                        text
                        >Подтвердить</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>

            <v-text-field
              class="top20"
              v-model="search"
              label="Введите наименование/артикул товара"
              type="text"
              prepend-inner-icon="mdi-magnify"
              clearable
            ></v-text-field>

            <product-list-row
              v-for="good in goodList"
              :key="good.id"
              :good="good"
              :paymentIsAvailable="paymentIsAvailable"
              :updSum="updSum"
              :deletionProhibited="deletionProhibited"
              :upd="upd"
              @rejectReason="setRejectReason"
              @deletedGoodExtId="setDeletedGoodExtId"
            />

            <v-btn
              v-if="isUkdSubmitButtonAvailable"
              block
              class="goods-link"
              @click="onConfirmCorrectChanges"
              :disabled="!hasBeenCorrect"
            >
              <v-icon dark> mdi-checkbox-marked-circle-outline </v-icon>
              Подтвердить корректировку УПД
            </v-btn>
          </div>

          <v-spacer></v-spacer>

          <v-btn
            block
            x-large
            @click="onSendCheck"
            class="send-check top20"
            v-if="paymentIsAvailable && !isRejected"
          >
            <v-icon dark> mdi-rocket-launch </v-icon>
            Отправить чек на сумму
            <div class="text-h6">
              {{ updSum }} <span class="currency-rub"></span>
            </div>
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            block
            x-large
            class="send-check"
            @click="onCorrecting"
            v-if="paymentIsAvailable && !isRejected"
          >
            Сформировать чек на другую сумму
          </v-btn>

          <v-spacer></v-spacer>
        </v-card-text>
      </v-card>

      <correct-sum
        :updSum="updSum"
        :upd="upd"
        v-if="isCorrectingSum"
        @sendCheck="onConfirmedSendCheck"
      />

      <v-spacer></v-spacer>

      <v-container class="top40">
        <v-row align="center" justify="space-around">
          <v-btn
            v-if="upd"
            class="readmore-link"
            color="white"
            @click="onSearch"
          >
            <v-icon dark> mdi-arrow-u-left-bottom </v-icon>
            {{ backButtonName }}
          </v-btn>
        </v-row>
      </v-container>
    </div>
    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>

    <take-photo
      v-if="openCamera"
      :deletedGoodExtId="deletedGoodExtId"
      @openCamera="setOpenCamera"
    />
  </div>
</template>

<script>
import ProductListRow from "@/components/ProductListRow";
import ConfirmDialogue from "@/components/ConfirmDialogue.vue";
import CorrectSum from "@/components/CorrectSum";
import TakePhoto from "@/components/TakePhoto";

export default {
  name: "MrmvUpd",
  components: {
    ProductListRow,
    ConfirmDialogue,
    CorrectSum,
    TakePhoto,
  },
  props: {
    upd: Object,
  },
  data: () => ({
    search: "",
    showDetails: false,
    dialogMessage: "",
    dialogTitle: "",
    dialog: false,
    updRejectDialog: false,
    dialogError: false,
    loading: false,
    rejectReason: false,
    takePhoto: false,
    openCamera: false,
    deletedGoodExtId: null,
    removeAllGoodsReason: null,
  }),
  computed: {
    isRejected() {
      return this.$store.getters.isUpdRejectIsExist;
    },
    updRejectResultData() {
      return this.$store.getters.updRejectResult;
    },
    isAllGoodsRemoveButtonDisabled() {
      return this.goodsForReturnIsAvailable && this.isAllGoodsAreRemoved;
    },
    isUkdSubmitButtonAvailable() {
      return !(
        this.upd !== null &&
        this.upd.contractor.contract.contractType === 3 &&
        this.isAllGoodsAreRemoved === false &&
        this.$store.getters.updSum >= 0
      );
    },
    isAllGoodsAreRemoved() {
      let allGoodsCount = 0;
      this.goods.forEach((item) => {
        allGoodsCount += item.initial_amount;
      });
      let allUkdGoodsCount = 0;
      this.goods.forEach((item) => {
        item.draftUkdList.forEach((draftUkd) => {
          allUkdGoodsCount += draftUkd.quantity;
        });
      });
      return allGoodsCount === allUkdGoodsCount;
    },
    isPaid() {
      return this.$store.getters.isPaid;
    },
    goodsForReturnIsAvailable() {
      return this.$store.getters.goodsForReturnIsAvailable;
    },
    hasBeenCorrect() {
      let canceled = this.$store.getters.getcanceledGoods;
      return canceled.length > 0;
    },
    debt() {
      return this.$store.getters.debt;
    },
    goodList() {
      let oldGoodList = this.goods;
      let newGoodList = [];

      if (this.search === null) {
        newGoodList = oldGoodList;
        return newGoodList;
      }

      const search = this.search.toLowerCase();
      let key;
      let el;

      for (key in oldGoodList) {
        el = oldGoodList[key];
        if (
          el.name.toLowerCase().indexOf(search) !== -1 ||
          el.article.toLowerCase().indexOf(search) !== -1
        ) {
          newGoodList.push(el);
        }
      }

      return newGoodList;
    },
    backButtonName() {
      return this.isCorrectingSum ? "Вернуться к поиску УПД" : "Назад";
    },
    goods() {
      return this.$store.getters.goods;
    },
    updSum() {
      return this.$store.getters.updSum;
    },
    isCorrectingSum() {
      return this.$store.getters.isCorrectingSum;
    },
    paymentIsAvailable() {
      return (
        this.updSum > 0 &&
        !this.isPaid &&
        this.upd.contractor.contract.contractType !== 1 &&
        this.upd.contractor.contract.contractType !== 2
      );
    },
    deletionProhibited() {
      return this.upd != null && this.upd.deleteProhibited;
    },
  },
  methods: {
    setOpenCamera(openCamera) {
      this.openCamera = openCamera;
    },
    setRejectReason(rejectReason) {
      this.rejectReason = rejectReason;
    },
    setDeletedGoodExtId(deletedGoodExtId) {
      this.deletedGoodExtId = deletedGoodExtId;
    },
    onShowDetails() {
      this.showDetails = !this.showDetails;
    },
    onScan() {
      this.$store.commit("clearUpd");
      this.$store.commit("clearCanceledGoods");
      this.$store.commit("finishCorrectSum");
      this.$router.push({ name: "UpdScan" });
    },
    onRejectDeleteAllButton() {
      this.updRejectDialog = false;
    },
    onSubmitDeleteAllButton() {
      this.loading = true;
      this.updRejectDialog = false;
      if (this.upd.uksCount === 0) {
        this.$store
          .dispatch("updReject", this.upd.searchNumber)
          .then((response) => {
            this.$store.dispatch("setUpdRejectResult", response.data.result);
            // this.updRejectResult = response.data.result;
          })
          .catch(() => {
            this.$store.dispatch("setUpdRejectResult", "error");
            // this.updRejectResult = "error";
          })
          .finally(() => {
            this.loading = false;
            this.showDetails = false;
          });
      } else {
        this.$store
          .dispatch("ukd_goods_all", {
            upd: this.upd,
            reason: this.removeAllGoodsReason,
          })
          .then(() => {
            this.dialog = true;
            this.dialogTitle = "Успешно";
            this.dialogMessage = "Корректировка УПД отправлена";
            this.dialogError = false;
          })
          .catch((err) => {
            this.dialogError = true;
            this.dialog = true;
            this.dialogTitle = "УКД не сформирована";
            let error = JSON.parse(err.request.responseText);
            this.dialogMessage = error.message;
            this.loading = false;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    onGoMain() {
      this.$store.commit("clearUpd");
      this.$store.commit("clearCanceledGoods");
      this.$store.commit("finishCorrectSum");
      this.$router.push({ name: "Home" });
    },
    onSearch() {
      this.$refs.confirmDialogue
        .show({
          title: "Покинуть страницу",
          message: "Вернуться к поиску УПД?",
          okButton: "Да",
          showEmail: false,
        })
        .then((result) => {
          if (result) {
            this.dialog = false;
            this.$store.commit("clearUpd");
            this.$store.commit("clearCanceledGoods");
            this.$store.commit("finishCorrectSum");
          }
        });
    },
    onConfirmCorrectChanges() {
      this.$refs.confirmDialogue
        .show({
          title: "УПД оплачена",
          message: "Подтвердите корректировку оплаченной УПД",
          okButton: "Подтверждаю",
        })
        .then((result) => {
          if (result) {
            this.loading = true;
            if (this.upd.uksCount === 0 && this.isAllGoodsAreRemoved) {
              this.$store
                .dispatch("updReject", this.upd.searchNumber)
                .then((response) => {
                  this.$store.dispatch(
                    "setUpdRejectResult",
                    response.data.result
                  );
                  // this.updRejectResult = response.data.result;
                })
                .catch(() => {
                  this.$store.dispatch("setUpdRejectResult", "error");
                  // this.updRejectResult = "error";
                })
                .finally(() => {
                  this.loading = false;
                  this.showDetails = false;
                });
            } else {
              this.$store
                .dispatch("ukd_goods", {
                  updSearchNumber: this.$store.getters.searchNumber,
                  ukdGoods: this.$store.getters.getcanceledGoods,
                })
                .then(() => {
                  this.dialog = true;
                  this.dialogTitle = "Успешно";
                  this.dialogMessage = "Корректировка УПД отправлена";
                  this.dialogError = false;
                })
                .catch((err) => {
                  this.dialogError = true;
                  this.dialog = true;
                  this.dialogTitle = "УКД не сформирована";
                  let error = JSON.parse(err.request.responseText);
                  this.dialogMessage = error.message;
                  this.loading = false;
                })
                .finally(() => {
                  this.loading = false;
                });
            }
          }
        });
    },
    onCorrecting() {
      this.$refs.confirmDialogue
        .show({
          title: "Изменить сумму?",
          message: "Текущая сумма: ",
          item: this.$store.getters.updSum + " руб",
          okButton: "Изменить",
        })
        .then((result) => {
          if (result) {
            this.$store.commit("startCorrectSum");
          }
        });
    },
    onSendCheck() {
      this.$refs.confirmDialogue
        .show({
          title: "Отправить чек",
          message: "Чек на сумму",
          item: this.$store.getters.updSum + " руб",
          okButton: "Отправить",
          showEmail: true,
          email: this.upd.contractor.email,
        })
        .then((result) => {
          if (result) {
            this.$store
              .dispatch("ukd_goods", {
                updSearchNumber: this.$store.getters.searchNumber,
                ukdGoods: this.$store.getters.getcanceledGoods,
              })
              .then(() => {
                this.createCheck();
                this.onConfirmedSendCheck();
              })
              .catch((err) => {
                this.dialogError = true;
                this.dialog = true;
                this.dialogTitle = "УКД не сформирована";
                let error = JSON.parse(err.request.responseText);
                this.dialogMessage = error.message;
                this.loading = false;
              });
          }
        });
    },
    createCheck() {
      let check = {
        checkExtid: this.$uuid.v4(),
        contractExtid: this.upd.contractor.contract.id,
        contractNumber: this.upd.contractor.contract.number,
        contractorName: this.upd.contractor.name,
        deliveryAddress: this.upd.deliveryAddress.name,
        transporterExtid: this.upd.transporterExtid,
        updExtid: this.upd.docId.toString(),
        updNumber: this.upd.docNumber,
        amount: this.$store.getters.updSum.toString(),
        email: this.$store.getters.getContractorEmail,
        isPrepaid: false,
        upd: this.upd,
      };
      this.$store.commit("fillCheckToSend", check);
      this.$store.commit(
        "updateCheckSum",
        parseFloat(this.$store.getters.updSum)
      );
    },
    onConfirmedSendCheck(
      quiet = false,
      successMessage = null,
      successTitle = "Чек сформирован"
    ) {
      this.loading = true;
      let check = this.$store.getters.checkToSend;
      let action =
        check.isPrepaid === true ? "create_new_prepaid" : "create_new_upd";
      this.$store
        .dispatch(action, check)
        .then(() => {
          if (quiet === false) {
            this.dialog = true;
            this.dialogTitle = successTitle;
            this.dialogMessage =
              successMessage === null
                ? "Чек на сумму " +
                  this.$store.getters.checkSum +
                  " руб. успешно сформирован."
                : successMessage;
            this.dialogError = false;
          }
          this.$store.commit("clearCheckToSend");
        })
        .catch((err) => {
          this.dialogError = true;
          this.dialog = true;
          this.dialogTitle = "Чек не сформирован";
          let error = JSON.parse(err.request.responseText);
          this.dialogMessage = error.message;
          this.loading = false;
        })
        .finally(() => {
          if (quiet === false) {
            this.loading = false;
          }
        });
    },
  },
};
</script>
